
import React, { Component } from 'react';
import Layout from "../../shared/components/layouts/MainLayout";
import { connect } from "react-redux";
import { push } from "react-router-redux";

import circleCheck from "../../../assets/images/circle-check.svg";

class RCLRequestReceivedInstruction extends Component {
  goBackHome = () => {
    this.props.push("/");
  }

  render() {
    return (
      <Layout gridClassName="--narrow">
        <div className="ds-card _textAlign_center _padding--xlarge">
          <section className="cardSection">
          <img className="_marginBottom--normal" src={circleCheck} alt="Circle Check" />
            <h2 className="headline -primary _fontSize--xlarge _marginBottom--small">We received your loan request!</h2>
            <p className="_marginBottom--small byline"><b>Your request is now being verified.</b></p>

            <p className="_marginBottom--medium byline">
              Once approved, the loan contract and instructions on what to do next will be sent to
              <span className="_marginBottom--small -primary">
                <b>{` ${this.props.user_email}`}</b>
              </span>
            </p>

            <button
              className="ds-btn --block -primary"
              onClick={this.goBackHome}
              data-testid='go-back-home-button'
            >
              Go back to homepage
            </button>
          </section>
        </div>
      </Layout>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    leadId: (state.user.active_business_trustpass || {}).lead_id,
    user_email: state.user.email,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    push: (url) => dispatch(push(url)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RCLRequestReceivedInstruction);



// WEBPACK FOOTER //
// ./src/features/loans/containers/RCLRequestReceivedInstruction.js